<template>
  <div>
    <DropDownSelect
      data-test-id="dropDownSelect"
      label="Status"
      name="EncryptionStatus"
      :options="options"
      :value="model.status"
      @input="(newValue) => setAttribute('status', newValue)"
    />
  </div>
</template>

<script>
import { ExpressionStatus } from 'client/Security/data/Condition';
import ConditionDeviceEncrypted from 'client/Security/data/ConditionDeviceEncrypted';
import DropDownSelect from 'client/components/DropDownMenu/DropDownSelect.vue';

export default {
  name: 'ConditionRowDeviceEncrypted',

  components: {
    DropDownSelect,
  },

  props: {
    value: {
      type: ConditionDeviceEncrypted,
      default: () => new ConditionDeviceEncrypted(),
    },
  },

  data() {
    return {
      model: null,

      options: [
        { name: 'Disk Encryption Disabled', value: ExpressionStatus.exclude },
        { name: 'Disk Encryption Enabled', value: ExpressionStatus.include },
      ],
    };
  },

  beforeMount() {
    this.model = this.value;

    this.$emit('input', this.model);
  },

  methods: {
    setAttribute(key, value) {
      this.model[key] = value;

      this.$emit('input', this.model);
    },
  },
};
</script>
